// ~/stores/modal.ts
import { defineStore } from 'pinia'

// wrap it so it's only loaded on demand
const LoginModal = defineAsyncComponent(() =>
  import('~/components/modals/LoginModal.vue'),
)
const PlannerCalendarModal = defineAsyncComponent(() =>
  import('~/components/modals/PlannerCalendarModal.vue'),
)
const MobileSidebar = defineAsyncComponent(() =>
  import('~/components/UI/MobileSideBar.vue'),
)
const PromoModal = defineAsyncComponent(() =>
  import('~/components/modals/PromoModal.vue'),
)
const ScoreModal = defineAsyncComponent(() =>
  import('~/components/modals/ScoreModal.vue'),
)
const CancelExtraModal = defineAsyncComponent(() =>
  import('~/components/modals/CancelExtraModal.vue'),
)
const VideoModal = defineAsyncComponent(() =>
  import('~/components/modals/VideoModal.vue'),
)
const BuyExtraPromoModal = defineAsyncComponent(() =>
  import('~/components/modals/BuyExtraPromo.vue'),
)

export const useModalStore = defineStore('modal', () => {
  const overlay = useOverlay()
  const baseStore = useBaseStore()
  const showSearchModal = ref(false)

  function openWithAdHide<T>(openFn: () => T): T {
    baseStore.incrementModalOpen()
    const result = openFn()
    void Promise.resolve(result).finally(() => baseStore.decrementModalOpen())
    return result
  }

  function openLoginModal(options?: { forgotPassword?: boolean, email?: string }) {
    openWithAdHide(() => {
      const modal = overlay.create(LoginModal, {
        props: {
          modelValue: true,
          initialForgotPassword: options?.forgotPassword ?? false,
          prefillEmail: options?.email ?? '',
        },
      })
      return modal.open()
    })
  }

  function openPlannerCalendarModal(recipe?) {
    openWithAdHide(() => {
      const modal = overlay.create(PlannerCalendarModal, {
        props: { recipe },
      })
      return modal.open()
    })
  }

  function openItemModal(itemId?) {
    openWithAdHide(() => {
      const modal = overlay.create(PromoModal, {
        props: { itemId },
      })
      return modal.open()
    })
  }

  function openMobileSidebar() {
    openWithAdHide(() => {
      const modal = overlay.create(MobileSidebar)
      return modal.open()
    })
  }

  function openScoreHelpModal() {
    openWithAdHide(() => {
      const modal = overlay.create(ScoreModal)
      return modal.open()
    })
  }

  function openCancelExtraModal() {
    openWithAdHide(() => {
      const modal = overlay.create(CancelExtraModal)
      return modal.open()
    })
  }

  function openVideoModal() {
    openWithAdHide(() => {
      const modal = overlay.create(VideoModal)
      return modal.open()
    })
  }

  function openExtraVideoModal() {
    openWithAdHide(() => {
      const modal = overlay.create(VideoModal, {
        props: {
          metaId: 'extra-video',
          videoId: 'f2345bbb-d4b6-4fd9-abf8-4084554cb85c',
        },
      })
      return modal.open()
    })
  }

  function openPromoBannerModal() {
    openWithAdHide(() => {
      const modal = overlay.create(BuyExtraPromoModal)
      return modal.open()
    })
  }

  return { openLoginModal, openPlannerCalendarModal, openScoreHelpModal, openItemModal, showSearchModal, openMobileSidebar, openCancelExtraModal, openVideoModal, openExtraVideoModal, openPromoBannerModal }
})
